module.exports = __webpack_public_path__ + "img/shopping.2f17abcc.png";